import Navbar from "@/components/Navbar";

export default function PageShell({ children }) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <footer className="border-t border-border mt-16">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <p className="text-xs text-muted-foreground font-mono leading-relaxed max-w-4xl">
            <span className="text-primary uppercase tracking-widest">Disclaimer — </span>
            For educational purposes only. None of this shall be construed as legal advice.
          </p>
        </div>
      </footer>
    </div>
  );
}
